import { render, staticRenderFns } from "./BaseImageUploadInput.vue?vue&type=template&id=0797aa1a"
import script from "./BaseImageUploadInput.vue?vue&type=script&lang=js"
export * from "./BaseImageUploadInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports